<script lang="ts" setup>

//vue
import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/empresasService";
import {fdata, fdataUS} from "@/utils/funcoes";

//componentes
import TrataTecla from "@/components/TrataTecla/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import AutoCompleteClientes from "@/components/AutoCompletes/AutoCompleteClientes.vue";

interface IProps {
  EmpresaId?: number
}

var props = defineProps<IProps>();

  var controle = reactive({
    empresaId: props.EmpresaId as number | null | undefined,
    itens: [] as service.FuncionarioDto[],
    model: {
      empresaId: props.EmpresaId
    } as service.EmpresaFuncDto,
    janela: false,
    janPergunta:false,
    erro: "",
    status: ""
  })

  onMounted(() => {
   
    buscarItems();

  });

  watch(() => props.EmpresaId, (newValue) => {
    controle.empresaId = newValue;
    controle.model.empresaId = newValue ?? 0;
    buscarItems();
  });

  async function buscarItems() {

      if (!props.EmpresaId) {
        controle.itens = [];
        return;
      }

      console.log("buscando items empresaId: ", controle.empresaId);

      controle.status = "Buscando items...";
      controle.erro = "";
      service.obterFuncionarios(controle.empresaId as number)
      .then((r) => {
        controle.itens = r;
        controle.status = "";
      })
      .catch((error) => {
        controle.erro = `Erro ao buscar items: ${error}`;
        controle.status = "";
      });
  }
      
  async function adicionar() {

      controle.status = "Salvando item...";
      controle.erro = "";

      service.adicionarFuncionario(controle.model)
      .then(() => {
        controle.status = "";
        controle.model = {
          empresaId: controle.model.empresaId,
          clienteId: 0,
        } as service.EmpresaFuncDto;
        buscarItems();
        controle.janela = false;
      })
      .catch((error) => {
        controle.erro = `Erro ao salvar item: ${error}`;
        controle.status = "";
      });
  }

  function excluir(item: service.EmpresaFuncDto) {
    controle.model = item;
    controle.janPergunta = true;
  }

  function excluirConfirma()
  {
    console.log("excluir: ", controle.model);
    controle.janPergunta = false;
    controle.status = "Excluindo item...";
    controle.erro = "";

    service.excluirFuncionario(controle.model)
    .then(() => {
      controle.status = "";
      controle.model = {
        empresaId: controle.model.empresaId,
        clienteId: 0,
      } as service.EmpresaFuncDto;
      buscarItems();
    })
    .catch((error) => {
      controle.erro = `Erro ao excluir item: ${error}`;
      controle.status = "";
    });
  }


</script>

<template>
    <TrataTecla>
      <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
        <div class="card-header">
          <h5 class="card-title">Funcionários</h5>
        </div>
        <div class="card-body p-3">
          <div class="row mb-2">
            <div class="col-md-4">
              <AutoCompleteClientes v-model="controle.model.clienteId" :placeholder="'Digite o nome ou CPF'" @selected="(item) => { controle.model.clienteId = item.clienteId; }" />
            </div>
            <div class="col-md-6">
              <a class="btn btn-sm btn-primary " @click="adicionar()">Adicionar</a>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-md-12">
            <table class="table table-sm table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Plano</th>
                    <th>Nome</th>
                    <th>Nascimento</th>
                    <th>CPF</th>
                    <th>Celular</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in controle.itens" :key="index">
                      <td>{{ item.planoNome }}</td>
                      <td>{{ item.nome }}</td>
                      <td>{{ fdata(item.dataNascimento) }}</td>
                      <td>{{ item.cpf }}</td>
                      <td>{{ item.celular }}</td>
                    <td>
                      <button class="btn btn-sm btn-danger" title="Excluir registro" @click="excluir({  empresaId: controle.empresaId as number, clienteId: item.clienteId })">
                        <i class="flaticon-delete"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
            </table>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-12">
              <p class="">Registros: {{ controle.itens.length }}</p>
            </div>  
          </div>
          <div  class="text-center">
            <span class="">{{ controle.status }}</span> 
            <span class="text-danger fw-bold">{{ controle.erro }}</span>
          </div>
        </div>
      </div>
    </TrataTecla>

    <MsgBox :id="'janPergunta2'" class="modal-md" data-bs-backdrop="static" :exibir="controle.janPergunta"
              :titulo="'Atenção'" @on-fechou="controle.janPergunta = false" :botao-sim="true" 
              :botao-nao="true" @on-sim="excluirConfirma()">
        <div class="row mb-2">
          <div class="col-md-12 fs-5 fw-bold text-center ">
            Deseja excluir este registro ?
          </div>
        </div>
    </MsgBox>

</template>